<template>
  <a class="nav-link ${item.isActive ? 'active' : ''} ${item.settings.disabled ? 'disabled' : ''} ${item.settings.linkClass}" href.bind="item.href || '#'" title.bind="item.title || ''" click.delegate="linkClicked({ nav: item })">
    <i class.bind="item.settings.icon" if.bind="item.settings.icon"></i><span class="nav-link__title">${item.title}</span>
  </a>
</template>
